<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Attach Propulsion Scenario</h1>
  <div id="actions-container">
    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="add-button" class="action-button"
            (click)="onConfirm()"
            [disabled]="selectedRow === null">
      Confirm
    </button>
  </div>
</div>
<div mat-dialog-content class="d-flex flex-column gap-8 mh-100 h-100">
  <div class="d-flex flex-row justify-content-start align-items-baseline pe-3 gap-16">
    <mat-checkbox (change)="onCheckboxChange()"
                  [(ngModel)]="checkboxValue">
      Include Hidden Scenarios
    </mat-checkbox>
  </div>
  <div class="h-100">

    <ag-grid-angular
      style="height: 100%;"
      class="ag-theme-quartz"
      [rowData]="propScenarios"
      [columnDefs]="columnHeaders"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      (rowSelected)="onSelect($event)"
    />
  </div>
</div>
